import { AvatarGroup, type AvatarProps, Flex } from '@chakra-ui/react'

import type { HostAvatarDetails } from '@/components/Host/types'
import UserAvatar from '@/components/UserAvatar'

export default function MultipleUserAvatar({
  hosts,
  ...avatarProps
}: {
  hosts: HostAvatarDetails[]
} & AvatarProps): JSX.Element {
  const { border: _, size } = avatarProps

  return (
    <Flex align="center" justify="center">
      <AvatarGroup size={size} max={2}>
        {hosts.map(host => (
          <UserAvatar
            key={host.userId ?? 0}
            src={host.avatarSrc ?? ''}
            name={`${host.avatarName}`}
            progressionLevel={host.progressionLevel}
            position="relative"
            size={size ?? 'md'}
            {...avatarProps}
          />
        ))}
      </AvatarGroup>
    </Flex>
  )
}
